import { WorshipReport } from '../types/worshipReport';
import { FinanceReport } from '../types/financeReport';

export function calculateStats(worshipReports: WorshipReport[], financeReports: FinanceReport[]) {
  if (worshipReports.length === 0 && financeReports.length === 0) {
    return {
      totalParticipants: 0, // Moyenne des participants
      totalNewMembers: 0, // Moyenne des nouveaux membres
      totalFinances: 0,
      averageAttendance: 0,
      trends: {
        attendance: { value: 0, isPositive: true },
        newMembers: { value: 0, isPositive: true },
        finances: { value: 0, isPositive: true }
      }
    };
  }

  // Calculate averages from worship reports
  const totalParticipants = worshipReports.length > 0 
    ? Math.round(worshipReports.reduce((sum, report) => sum + report.totalParticipants, 0) / worshipReports.length)
    : 0;
  const totalNewMembers = worshipReports.length > 0
    ? Math.round(worshipReports.reduce((sum, report) => sum + report.totalNewMembers, 0) / worshipReports.length)
    : 0;
  
  // Calculate total finances from finance reports
  const totalFinances = financeReports.reduce((sum, report) => 
    sum + report.totalFinances, 
    0
  );

  // Calculate average attendance
  const averageAttendance = worshipReports.length > 0 ? totalParticipants : 0;

  // Calculate trends (comparing latest to previous)
  const calculateTrend = (current: number, previous: number) => {
    if (previous === 0) return { value: 0, isPositive: true };
    const percentChange = ((current - previous) / previous) * 100;
    return {
      value: Math.abs(Math.round(percentChange)),
      isPositive: percentChange >= 0
    };
  };

  // Get latest and previous worship reports for attendance trends
  const [latestWorship, previousWorship] = worshipReports.length >= 2 
    ? [worshipReports[0], worshipReports[1]] 
    : worshipReports.length === 1 
    ? [worshipReports[0], worshipReports[0]]
    : [null, null];
  
  // Get latest and previous finance reports for finance trends
  const [latestFinance, previousFinance] = financeReports.length >= 2 
    ? [financeReports[0], financeReports[1]] 
    : financeReports.length === 1 
    ? [financeReports[0], financeReports[0]]
    : [null, null];

  const trends = {
    attendance: latestWorship && previousWorship 
      ? calculateTrend(latestWorship.totalParticipants, previousWorship.totalParticipants)
      : { value: 0, isPositive: true },
    newMembers: latestWorship && previousWorship
      ? calculateTrend(latestWorship.totalNewMembers, previousWorship.totalNewMembers)
      : { value: 0, isPositive: true },
    finances: latestFinance && previousFinance
      ? calculateTrend(latestFinance.totalFinances, previousFinance.totalFinances)
      : { value: 0, isPositive: true }
  };

  return {
    totalParticipants,
    totalNewMembers,
    totalFinances,
    averageAttendance,
    trends
  };
}